import {
  PermissionAction,
  PermissionResource,
  PermissionScope,
} from "@/services/api/sdk";
import { useAuthStore } from "@/store/auth.ts";

type PermissionStringScopeSuffix = `.${Exclude<PermissionScope, "None">}`;
export type PermissionString =
  `${PermissionResource}.${PermissionAction}${PermissionStringScopeSuffix | ""}`;

// Order of user roles, from lowest to highest
const scopeHeirarchy: PermissionScope[] = [
  PermissionScope.User,
  PermissionScope.TeamMember,
  PermissionScope.TeamManager,
  PermissionScope.None,
];

export function userHasPermission(value: PermissionString): boolean {
  const authStore = useAuthStore();
  const [resource, action, scope] = value.split(".") as [
    PermissionResource,
    PermissionAction,
    PermissionScope | undefined,
  ];

  const userPermission = authStore.permissions?.find(
    (p) => p.resource === resource && p.action === action,
  );

  if (!userPermission) {
    return false;
  } else if (userPermission && !scope) {
    return true;
  }

  return (
    scopeHeirarchy.indexOf(userPermission?.scope!) >=
    scopeHeirarchy.indexOf(scope!)
  );
}
